import React from "react";

import { AccordionItemPropsTypes } from "@at/design-system-patterns";
import { getChannelCapitalised } from "@at/formatter-utils";
import { Channel } from "@at/sauron-platform-core";

import * as Styled from "./charging.styles";

export function HomeChargingPoint(
  channelCopy: string,
  channelSingular: string,
): AccordionItemPropsTypes[] {
  return [
    {
      rowHeading: "Home charge point (up to 7.4kW)",
      trackingLabel: "home-charge-point-7kw",
      rowContent: (
        <>
          <p>
            This is the standard type of home charging option that many electric{" "}
            {channelCopy} owners choose. A dedicated home charging point will
            charge your {channelSingular} faster than a domestic three-pin plug.
            It delivers up to 7.4 kiloWatts (kW) versus the 2.3 kW you get from
            using a domestic plug.
          </p>
          <Styled.BulletsList>
            <Styled.BulletsItem>
              You will need to get an electrician who is qualified to to install
              electric home charge units to install this for you.
            </Styled.BulletsItem>
            <Styled.BulletsItem>
              You will need access to off-road parking (such as a driveway).
            </Styled.BulletsItem>
            <Styled.BulletsItem>
              7 kW charging points provide 20 to 30 miles of driving range per
              one hour of charging.
            </Styled.BulletsItem>
          </Styled.BulletsList>
        </>
      ),
    },
  ];
}
export function DomesticThreePinPlug(
  channel: Channel,
  channelSingular: string,
): AccordionItemPropsTypes[] {
  return [
    {
      rowHeading: "Domestic three-pin plug (2.3kW)",
      trackingLabel: "domestic-pin-plug-2kw",
      rowContent: (
        <>
          <p>
            It is possible to charge an electric {channelSingular} using a
            traditional home three-pin plug and socket, but this option is only
            intended for occasional use and is not as efficient as using a
            dedicated charge point.
          </p>
          <Styled.BulletsList>
            <Styled.BulletsItem>
              Offers a quick fix when you need it.
            </Styled.BulletsItem>
            <Styled.BulletsItem>
              Most three-pin plug chargers provide around 5-10 miles of driving
              range per one hour of charging
            </Styled.BulletsItem>
            <Styled.BulletsItem>
              You will still need access to off-road parking.
            </Styled.BulletsItem>
            <Styled.BulletsItem>
              {`${getChannelCapitalised(channel)}`} should always be plugged
              directly into a socket. It is not recommended to use an extension
              cord.
            </Styled.BulletsItem>
          </Styled.BulletsList>
        </>
      ),
    },
  ];
}
